import { jsx as _jsx } from "react/jsx-runtime";
import { getKnownConnectorIconBase64 } from "@layerswap/wallet-core";
export const KnownWalletIcon = ({ id, className }) => {
    const src = getKnownConnectorIconBase64(id);
    if (!src)
        return null;
    return _jsx("img", { src: src, alt: "", "aria-hidden": "true", className: `object-contain ${className ?? ""}` });
};
